const stateChangeStart = $transitions => {
	$transitions.onStart({}, trans => {
		const $state = trans.router.stateService;
		const $log = trans.injector().get('$log');
		const NavSvc = trans.injector().get('NavSvc');
		const UtilitySvc = trans.injector().get('UtilitySvc');
		const $rootScope = trans.injector().get('$rootScope');
		const AuthSvc = trans.injector().get('AuthSvc');
		const $uibModalStack = trans.injector().get('$uibModalStack');
		const _isStatePublic = NavSvc.isStatePublic(trans.to().name);

		// dismiss all modals
		$uibModalStack.dismissAll();

		// set page title based on state title property
		$rootScope.pageTitle = $state.title ? $state.title : 'OnCall Air';

		// if is a public page don't check if user logged in
		if (!_isStatePublic && !AuthSvc.isLoggedIn()) {
			return $state.target('user.auth', {}, {reload: true});
		}

		if (!UtilitySvc.areCookiesEnabled() && !$rootScope?.appAlreadyRun && !_isStatePublic) {
			const $window = trans.injector().get('$window');
			$rootScope.appAlreadyRun = true;
			$log.error(`User's browser has cookies disabled accessing "${$window.location.href}"`);
			$state.target('user.auth', {}, {reload: true});
			return false;
		}
	});

	$transitions.onStart({to: 'preview.accepted'}, trans => {
		const AuthSvc = trans.injector().get('AuthSvc');
		const $rootScope = trans.injector().get('$rootScope');
		const user = AuthSvc.currentUser();
		$rootScope.pageTitle = user ? `${user.service_provider_name}  Proposal` : 'OnCall Air';
	});

	// Customer-facing pages: force light mode + brand skin on enter, restore on exit
	$transitions.onStart({to: ['preview.**', 'view.**']}, trans => {
		const ThemingService = trans.injector().get('ThemingService');
		const AuthSvc = trans.injector().get('AuthSvc');
		const user = AuthSvc.currentUser();

		ThemingService._previousTheme = sessionStorage.getItem('oca-theme');
		document.documentElement.setAttribute('data-bs-theme', 'light');
		document.documentElement.style.colorScheme = 'light';

		if (user?.theme) {
			ThemingService.generateSkin({
				brandPrimary: user.theme.primary_color,
				brandSecondary: user.theme.secondary_color,
			});
		}
	});

	$transitions.onStart({to: ['office.**', 'proposal.**', 'navigator']}, trans => {
		const ThemingService = trans.injector().get('ThemingService');
		ThemingService.resetSkin();

		if (ThemingService._previousTheme) {
			ThemingService.setTheme(ThemingService._previousTheme);
			ThemingService._previousTheme = null;
		}
	});
};
stateChangeStart.$inject = ['$transitions'];
export default stateChangeStart;
